import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { TopicListItem } from '@/types'
import { getTopics } from '@/api/endpoints/topics'
import { useAuth } from '@websanova/vue-auth'
import AppConfig from '@/config'

declare const window: Window

export const useCommonStore = defineStore('common', () => {
	// boolean-флаг: enable/disable используются по коду как переключатели (вкл/выкл),
	// поэтому refcount тут не подходит (несбалансированные вызовы залипают счётчик).
	// Защита от повторного входа — во внутреннем fetchCounter у withLoading (см. thread store).
	const loading = ref(false)
	const sendingMessage = ref(false)
	const internetErrorDialog = ref(false)
	// Модалка «войдите, чтобы...» для гостя в internal-режиме. Держим в store, а не локально
	// в хедере: её же должны открывать другие гостевые экшены (генерация и т.п.).
	const loginModal = ref(false)
	const auth = useAuth()
	const topicsArray = ref<TopicListItem[]>([])

	const hideApp = computed(() => !auth.check() && AppConfig.authMode !== 'internal')
	const hasTopics = computed(() => topicsArray.value.length > 0)
	const userAuth = computed(() => auth.check())

	function enableLoading() {
		loading.value = true
	}
	function disableLoading() {
		loading.value = false
	}
	function resetLoading() {
		loading.value = false
	}
	function enableSendingMessage() {
		sendingMessage.value = true
	}
	function disableSendingMessage() {
		sendingMessage.value = false
	}
	function openInternetErrorDialog() {
		internetErrorDialog.value = true
	}
	function closeInternetErrorDialog() {
		window.location.href = '/'
		internetErrorDialog.value = false
	}
	function openLoginModal() {
		loginModal.value = true
	}
	function closeLoginModal() {
		loginModal.value = false
	}
	async function fetchTopics() {
		if (!hasTopics.value) {
			try {
				const answer = await getTopics()
				topicsArray.value = answer.data
			} catch (e) {
				console.error(e)
			}
		}
	}

	return {
		loading,
		sendingMessage,
		internetErrorDialog,
		loginModal,
		auth,
		topicsArray,
		hideApp,
		hasTopics,
		userAuth,
		enableLoading,
		disableLoading,
		resetLoading,
		enableSendingMessage,
		disableSendingMessage,
		openInternetErrorDialog,
		closeInternetErrorDialog,
		openLoginModal,
		closeLoginModal,
		fetchTopics
	}
})
